// extracted by mini-css-extract-plugin
export default {"chip":"styles_chip__vJHG8"};